import { createFileRoute, redirect } from "@tanstack/react-router";

// The appel's address alone opens its first step.
export const Route = createFileRoute(
  "/_staff-area/cohorts/$cohortId/appels/$appelId/"
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/cohorts/$cohortId/appels/$appelId/programme",
      params,
      replace: true,
    });
  },
});
